import utils from "utils";

const convert = (value, currentUnit, wantedUnit) => {
    return utils.convertWindowSize(value, currentUnit, wantedUnit);
};

const round = (number, decimalPlaces) => +(Math.round(number + "e+" + decimalPlaces) + "e-" + decimalPlaces);

export default function(values, ownProps) {
    let errors = {};

    // Form : Room
    if (!values.WindowRoomId) {
        errors.WindowRoomId = "Please select a room.";
    }

    // Form: Style
    if (!values.WindowStyleId) {
        errors.WindowStyleId = "Please select a style.";
    }

    // Form: Design
    if (!values.WindowDesignId) {
        errors.WindowDesignId = "Please select a design.";
    }

    // Form: Size
    errors.WindowSize = {};
    if (values.WindowSize) {
        if (values.WindowSize.Type !== "approximate") {
            if (!values.WindowSize.Width) {
                errors.WindowSize.Width = "Please specify a window width";
            }

            if (!values.WindowSize.Height) {
                errors.WindowSize.Height = "Please specify a window height";
            }
        }

        let limits = ownProps.dimensionLimits;

        if (values.WindowSize.Width && ownProps.dimensionLimits) {
            let currentWidth = convert(values.WindowSize.Width, values.WindowSize.Unit, "mm");

            if (currentWidth < limits.Width.Min || currentWidth > limits.Width.Max)
                errors.WindowSize.Width =
                    "The width has to be between " +
                    round(convert(limits.Width.Min, "mm", values.WindowSize.Unit), 2) +
                    values.WindowSize.Unit +
                    " and " +
                    round(convert(limits.Width.Max, "mm", values.WindowSize.Unit), 2) +
                    values.WindowSize.Unit;
        }

        if (values.WindowSize.Height && ownProps.dimensionLimits) {
            let currentHeight = convert(values.WindowSize.Height, values.WindowSize.Unit, "mm");

            if (currentHeight < limits.Height.Min || currentHeight > limits.Height.Max)
                errors.WindowSize.Height =
                    "The height has to be between " +
                    round(convert(limits.Height.Min, "mm", values.WindowSize.Unit), 2) +
                    values.WindowSize.Unit +
                    " and " +
                    round(convert(limits.Height.Max, "mm", values.WindowSize.Unit), 2) +
                    values.WindowSize.Unit;
        }
    }

    // Form: Colour
    if (!values.WindowColourId) {
        errors.WindowColourId = "Please select a colour.";
    }

    // Form: Handle
    if (!values.WindowHandleId) {
        errors.WindowHandleId = "Please select a handle.";
    }

    // Form: WER
    if (!values.WindowEfficiencyId) {
        errors.WindowEfficiencyId = "Please select a WER rating";
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/containers/WindowForm/validate.js